<script>
  import Uppy from '@uppy/core'
  import AwsS3Multipart from '@uppy/aws-s3-multipart'
  import { onMount, onDestroy } from 'svelte'

  // Single-file Shrine attachment field for a model's direct attachment columns (e.g. Area/College
  // `image`/`logo`) — distinct from the Image-library model used elsewhere (image_selector.svelte).
  // Uploads straight to S3 cache via Uppy, then exposes the raw Shrine cache JSON string (bindable
  // `value`) for the form to submit as-is; the server assigns it directly to the attachment column.
  // `remove` (bindable) flips true when the admin clears an existing image without replacing it.
  let { value = $bindable(null), remove = $bindable(false), previewUrl = null, label } = $props()

  let url = $state(previewUrl)
  let uploading = $state(false)
  let uppy

  const csrfToken = () => document.querySelector('meta[name="csrf-token"]')?.content

  onMount(() => {
    uppy = new Uppy({ autoProceed: true }).use(AwsS3Multipart, {
      companionUrl: '/',
      companionHeaders: { 'X-CSRF-Token': csrfToken() }
    })

    uppy.on('upload-success', (file, response) => {
      const match = response.uploadURL.match(/\/cache\/([^?]+)/)
      if (!match) return

      const cacheKey = decodeURIComponent(match[1])
      value = JSON.stringify({
        id: cacheKey,
        storage: 'cache',
        metadata: { size: file.size, filename: file.name, mime_type: file.type }
      })
      remove = false
      url = URL.createObjectURL(file.data)
    })

    uppy.on('complete', () => {
      uploading = false
    })
  })

  onDestroy(() => uppy?.close())

  const onFilePick = (event) => {
    const file = event.target.files[0]
    if (!file) return
    uploading = true
    uppy.addFile({ name: file.name, type: file.type, data: file })
    event.target.value = ''
  }

  const removeImage = () => {
    value = null
    remove = true
    url = null
  }
</script>

<fieldset class="fieldset">
  {#if label}<legend class="fieldset-legend">{label}</legend>{/if}
  <div class="flex flex-col items-start gap-2">
    {#if url}
      <img src={url} alt={label} class="max-w-[200px] max-h-[200px] object-contain rounded-box border border-base-300" />
    {/if}
    <div class="flex items-center gap-2">
      <input type="file" accept="image/*" class="file-input file-input-sm" onchange={onFilePick} disabled={uploading} />
      {#if url}
        <button type="button" class="btn btn-ghost btn-xs" onclick={removeImage}>Remove</button>
      {/if}
    </div>
    {#if uploading}<span class="text-xs text-base-content/60">Uploading…</span>{/if}
  </div>
</fieldset>
